import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08652580"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "text-muted"
}

import { computed } from "vue";
import { Line } from "vue-chartjs";
import {
  Chart,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";


export default /*#__PURE__*/_defineComponent({
  props: {
    labels: null,
    datasets: null,
    title: null,
    height: null,
    yTickFormat: null
  },
  setup(__props: any) {

const props = __props as {
  labels: string[];
  // datasets: [{ label, data: number[] }]
  datasets: Array<{ label: string; data: number[] }>;
  title?: string;
  height?: number;
  yTickFormat?: (v: number) => string; // optional pretty format
}

Chart.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Title
);



const height = computed(() => props.height ?? 420);
const fmt = (n: number) =>
  props.yTickFormat
    ? props.yTickFormat(n)
    : new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(n);

const palette = [
  {
    borderColor: "rgba(24, 138, 138, 1)",
    backgroundColor: "rgba(24, 138, 138, 0.2)",
  },
  {
    borderColor: "rgba(255, 99, 132, 1)",
    backgroundColor: "rgba(255, 99, 132, 0.2)",
  },
  {
    borderColor: "rgba(54, 162, 235, 1)",
    backgroundColor: "rgba(54, 162, 235, 0.2)",
  },
  {
    borderColor: "rgba(255, 205, 86, 1)",
    backgroundColor: "rgba(255, 205, 86, 0.2)",
  },
  {
    borderColor: "rgba(153, 102, 255, 1)",
    backgroundColor: "rgba(153, 102, 255, 0.2)",
  },
];

const chartData = computed(() => ({
  labels: props.labels,
  datasets: props.datasets.map((d, i) => ({
    label: d.label,
    data: d.data,
    fill: false,
    borderWidth: 2,
    tension: 0.25,
    ...palette[i % palette.length],
  })),
}));

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: "top" as const },
    title: {
      display: !!props.title,
      text: props.title,
      font: { size: 18, weight: "bold" as const },
    },
    tooltip: {
      backgroundColor: "rgba(0,0,0,0.8)",
      titleColor: "#fff",
      bodyColor: "#fff",
      borderColor: "#fff",
      borderWidth: 1,
    },
  },
  scales: {
    x: { grid: { color: "rgba(200,200,200,0.3)" } },
    y: {
      grid: { color: "rgba(200,200,200,0.3)" },
      ticks: {
        callback: (value: number | string) => fmt(Number(value)),
      },
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (__props.labels?.length && __props.datasets?.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({ height: `${_unref(height)}px`, margin: '20px 0' }),
        class: "chart-container"
      }, [
        (_openBlock(), _createBlock(_unref(Line), {
          key: JSON.stringify([__props.labels, __props.datasets]),
          data: _unref(chartData),
          options: _unref(chartOptions)
        }, null, 8, ["data", "options"]))
      ], 4))
    : (_openBlock(), _createElementBlock("p", _hoisted_1, "No data to chart."))
}
}

})